/**
 * Plain-language names for domain enums.
 *
 * The same walk-away gate is named in the comparison table, the trajectory
 * chart's marker and the ledger's outcome line. Three copies of the mapping is
 * three chances for the same session to be described three ways, which is
 * precisely the kind of small inconsistency that makes a reader distrust
 * everything else on the screen. One map, imported.
 *
 * `spins` and `max-spins` are deliberately distinct: the first is the upper
 * stop the player chose, the second is the safety rail that stops an uncapped
 * session running forever. Collapsing them would report a rail as a decision.
 */

import type { SessionEnd } from '~/domain/session';

export const SESSION_END_LABELS: Readonly<Record<SessionEnd, string>> = {
  bust: 'bust',
  'stop-loss': 'stop-loss',
  spins: 'spin count',
  'pocket-target': 'target',
  'max-spins': 'spin cap',
  unplayable: 'unplayable',
};
